// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K4eR9","type":"styles_type__32w8r","choices":"styles_choices__1tavk"};